const partner = `
Vous êtes commerçant et souhaitez rejoindre notre communauté ? C’est simple ! Créer un compte partenaire sur Dealygo vous permet de :
Publier vos offres et coupons de réduction.
Attirer de nouveaux clients qualifiés grâce à notre plateforme.
Suivre vos performances et gérer vos promotions facilement.
Pour devenir partenaire, il vous suffit de vous inscrire sur notre page dédiée aux commerçants, remplir vos informations et créer votre compte. Une fois votre profil validé, vous pourrez commencer à proposer vos offres et profiter de tous les avantages de Dealygo.
Rejoignez Dealygo dès aujourd’hui et donnez plus de visibilité à votre commerce !
`;

export default partner;
